"use strict";

require("./CompanyUserRoleService.js");

CompanyUserRoleNewCtrl.$inject = [
  "$scope",
  "$state",
  "$modal",
  "$stateParams",
  "$translate",
  "CompanyUserRoleService",
  "growl",
];

function CompanyUserRoleNewCtrl(
  $scope,
  $state,
  $modal,
  $stateParams,
  $translate,
  CompanyUserRoleService,
  growl
) {
  $scope.users = [];
  $scope.userRole = {
    template: {
      id: "6",
    },
    links: [],
    menus: [],
  };

  $scope.save = function() {
    CompanyUserRoleService.save(
      { companyId: $stateParams.companyId },
      $scope.userRole,
      function(resp, headers) {
        growl.addSuccessMessage(
          $translate.instant("user-role.create-role-success")
        );
        // if (headers("Location")) {
        //   var newId = headers("Location")
        //     .split("/")
        //     .pop();

        //   $state.go("root.company.edit-dashboard", {
        //     roleId: newId,
        //   });
        // } else {
          $state.go("^.list");
        // }
      },
      function() {
        growl.addErrorMessage(
          $translate.instant("user-role.create-role-failure")
        );
      }
    );
  };

  $scope.useDashboard = function(templateId) {
    if (!$scope.role.template) {
      $scope.role.template = { id: templateId };
    } else {
      $scope.role.template.id = templateId;
    }
  };
}

angular
  .module("dokiv")
  .controller("CompanyUserRoleNewCtrl", CompanyUserRoleNewCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/user-roles/CompanyUserRoleNewCtrl.js
// module id = 428
// module chunks = 0